import React, { useEffect, useState } from "react";
import { helpAndSupportListController } from "../../services/helpAndSupportServices/helpAndSupportController";
import { Link } from "react-router-dom";
import ToggleStatus from "../../common/ToggleStatus";
import { FormControlLabel } from "@mui/material";
import { toast } from "react-toastify";
import {
  dateFormat,
  dateFormatYear,
  showDateFormatYear,
  subtractAndFormatDate,
} from "../../utility/utils";
import ModalBox from "../../common/ModalBox";
import useButtonLoader from "../../hooks/useButtonLoader";
import useDebounce from "../../hooks/useDebounce";
import Pagination from "react-js-pagination";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { red } from "@mui/material/colors";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import {
  deleteOfferController,
  offersListingController,
} from "../../services/offersServices/offersManagementController";
import { vendorListController } from "../../services/vendorServices/vendorServices";
import {
  deleteSchemeController,
  schemeListController,
} from "../../services/schemeServices/schemeController";
import {
  bundleListController,
  changeBundleStatusController,
  deleteBundleController,
} from "../../services/bundleServices/bundleController";
import { usePermission } from "../../context/create_Context";
import { actionsChecker, permissionChecker } from "../../config/roleAccess";

function BundleManagement() {
  const [bundleList, setBundleList] = useState([]);
  const [search, setSearch] = useState("");
  const [totalList, setTotalList] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [bundleId, setBundleId] = useState("");
  const [startNumber, setStartNumber] = useState();
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const debounceValue = useDebounce(search, 500);
  const [loader, show, hide] = useFullPageLoader();
  const [submitButton, setSubmitButton] = useButtonLoader();
  const { permission } = usePermission();
  const role = localStorage.getItem("role");
  const isSeller = role === "seller" ? true : false;

  const fetchBundleList = async () => {
    try {
      show();
      const response = await bundleListController(
        activePage ? activePage : "",
        limit ? limit : "",
        search ? search : ""
      );
      // console.log(response?.data?.data?.scheme, "----------->");
      if (response?.data?.code === 200) {
        hide();
        setBundleList(response?.data?.data?.bundle);
        setTotalList(response?.data?.data?.count);
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
        hide();
      }
    } catch (e) {
      console.log(e.message);
      hide();
    }
  };

  // Delete Scheme Handler
  const deleteBundleHandler = async () => {
    try {
      setSubmitButton(true);
      const response = await deleteBundleController(bundleId);
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message);
        setDeleteModal(false);
        setSubmitButton(false);
        fetchBundleList();
      } else {
        toast.error(response?.response?.data?.message);
        setDeleteModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      console.log(e.message);
      setSubmitButton(false);
    }
  };

  //   Change Budle Status Handler
  const bundleStatusHandler = async () => {
    try {
      setSubmitButton(true);
      const response = await changeBundleStatusController(bundleId);
      console.log(
        response?.data?.code
      )
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
        fetchBundleList();
      } else {
        toast.error(response?.data?.message);
        setStatusModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      console.log(e.message);
      setSubmitButton(false);
    }
  };

  //*Handle Pagination*
  const handlePageChange = (event) => {
    setActivePage(event);
  };

  useEffect(() => {
    setStartNumber((activePage - 1) * limit + 1);
  }, [activePage]);

  useEffect(() => {
    fetchBundleList();
  }, [debounceValue, limit, activePage]);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <div className="page_title_wrap">
              <h3 className="page-title">Bundle Management</h3>
              {permissionChecker(permission, 18, 1) && (
                <div className="button_wrap">
                  <Link
                    to="/bundle-management/add"
                    className="btn btn-btn btn-gradient-primary button"
                  >
                    <i className="mdi mdi-plus menu-icon menu-icon"></i> Add
                    Bundle
                  </Link>
                </div>
              )}
            </div>
          </div>

          <div className="row wrap_selectCstm my-4">
            <div className="col-1 cstm_padding_set">
              <select
                className="pageSelect input"
                onChange={(e) => setLimit(e.target.value)}
                value={limit}
              >
                <option value={"10"}>10</option>
                <option value={"25"}>25</option>
                <option value={"50"}>50</option>
                <option value={"100"}>100</option>
              </select>
            </div>
            <div className="col-lg-4 cstm_padding_set">
              <div className="search_box">
                <i className="mdi mdi-magnify"></i>
                <input
                  type="text"
                  className="form-control search"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          {loader}
          <div className="row wrap_selectCstm">
            <div className="col-lg-12 cstm_padding_set grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Created At</th>
                          <th>Bundle Name</th>
                          {!isSeller && <th>Seller Name</th>}
                          <th>No. Of Product</th>
                          <th>No. Of Stocks</th>
                          {actionsChecker(permission, 18) && <th>Actions</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {loader}
                        {bundleList && bundleList.length > 0 ? (
                          bundleList.map(
                            (
                              {
                                id,
                                bundleName,
                                bundlePrice,
                                sellerDetails,
                                createdAt,
                                noOfStock,
                                productCount,
                                bundleZohoId,
                                status,
                              },
                              index
                            ) => {
                              return (
                                <React.Fragment key={id}>
                                  <tr>
                                    <td>
                                      {(activePage - 1) * limit + ++index}
                                    </td>
                                    <td>{showDateFormatYear(createdAt)}</td>
                                    <td>{bundleName || "---"}</td>
                                    {!isSeller && <td>{sellerDetails?.sellerName || "---"}</td>}
                                    <td>{productCount || "---"}</td>
                                    <td>{noOfStock || "---"}</td>
                                    {actionsChecker(permission, 3) && (
                                      <td>
                                        <div className="action_button_wrap">
                                          {permissionChecker(
                                            permission,
                                            18,
                                            2
                                          ) && (
                                            <Link
                                              className="action_button"
                                              to={`/bundle-management/edit/${id}`}
                                            >
                                              <i class="mdi mdi-table-edit"></i>
                                            </Link>
                                          )}
                                          {permissionChecker(
                                            permission,
                                            18,
                                            3
                                          ) && (
                                            <Link
                                              className="action_button"
                                              to={`/bundle-management/view/${id}`}
                                            >
                                              <VisibilityIcon
                                                className="cstm_eye"
                                                color="secondary"
                                              />
                                            </Link>
                                          )}

                                      
                                          {permissionChecker(
                                            permission,
                                            18,
                                            5
                                          ) && (
                                            <div className="switch_button">
                                              <FormControlLabel
                                                control={
                                                  <ToggleStatus
                                                    onClick={() => {
                                                      setStatusModal(true);
                                                      setBundleId(id);
                                                    }}
                                                    sx={{ m: 1 }}
                                                    checked={status == 1}
                                                  />
                                                }
                                              />
                                            </div>
                                          )}
                                              {permissionChecker(
                                            permission,
                                            18,
                                            4
                                          ) && (
                                            <Link
                                              onClick={() => {
                                                setDeleteModal(true);
                                                setBundleId(id);
                                              }}
                                              className="action_button"
                                            >
                                              <DeleteRoundedIcon
                                                sx={{ color: red[500] }}
                                              />
                                            </Link>
                                          )}
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan={isSeller ? 6 : 7}>No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    <div>
                      <h5>
                        Showing {startNumber} to{" "}
                        {startNumber + bundleList?.length - 1} of {totalList}{" "}
                        entries
                      </h5>
                    </div>
                    {totalList > 10 ? (
                      <div className="pagination_wrap">
                        <Pagination
                          activePage={activePage}
                          linkClass="page-link"
                          previousLabel={"previous"}
                          nextLabel={"next"}
                          itemsCountPerPage={limit}
                          totalItemsCount={totalList}
                          pageRangeDisplayed={5}
                          itemClassLast="last_page next"
                          itemClassFirst="first_page prev"
                          activeLinkClass="active"
                          onChange={handlePageChange}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalBox
          status={deleteModal}
          onClose={() => setDeleteModal(false)}
          title="Delete Bundle"
          description={"Are you sure you want to delete this bundle?"}
          action={deleteBundleHandler}
          uploadButtonElement={submitButton}
        />

        {/* Status Modal */}
        <ModalBox
          status={statusModal}
          onClose={() => setStatusModal(false)}
          title="Change Status"
          description={"Are you sure you want to change status?"}
          action={bundleStatusHandler}
          uploadButtonElement={submitButton}
        />
      </div>
    </React.Fragment>
  );
}

export default BundleManagement;
